window.cpap.onDocumentReady(() => {
  // 🚨 This is only for user-blocking logic. Nothing that is user-visible or background should be included here!
  // @see https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API#task_priorities
  window.scheduler.postTask(
    () => {
      document.querySelectorAll('.footer-link-heading').forEach((node) => {
        node.addEventListener('click', () => {
          const siblingNode = node.nextElementSibling;
          const classListAction = siblingNode.classList.contains('open') ? 'remove' : 'add';
          node.classList[classListAction]('open');
          siblingNode.classList[classListAction]('open');
        });
      });
    },
    { priority: 'user-blocking' }
  );
});
